import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useSelector } from "react-redux";

function ProtectedRoute({ component: Component, ...restOfProps }) {
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);

  return (
    <Route
      {...restOfProps}
      render={(props) => (isLoggedIn ? <Component {...props} /> : <Redirect to="/?noAuth" />)}
    />
  );
}

export default ProtectedRoute;
